import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
	standalone: false,
	selector: "cba-add-place-of-birth-modal-insi-web-ay",
	templateUrl: "./add-place-of-birth-modal-insi-web-ay.component.html",
	styleUrls: ["./add-place-of-birth-modal-insi-web-ay.component.scss"],
})
export class AddPlaceOfBirthModalInsiWebAyComponent implements OnInit {
	theForm: UntypedFormGroup;

	constructor(
		private fb: UntypedFormBuilder,
		public dialogRef: MatDialogRef<AddPlaceOfBirthModalInsiWebAyComponent>,
	) {
		this.theForm = this.fb.group({
			placeOfBirth: ["", [Validators.required]],
		});
	}

	ngOnInit() {}

	continue() {
		if (this.theForm.valid) {
			this.dialogRef.close(this.theForm.controls.placeOfBirth.value);
		}
	}

	onCancel() {
		this.dialogRef.close();
	}
}
